import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function MobileBlocker() {
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (!isMobile || !isAdminRoute) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-teal-500 to-teal-600 z-[9999] flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="ri-computer-line text-4xl text-teal-600"></i>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-3">
          Área Administrativa
        </h1>
        
        <p className="text-gray-600 mb-6 leading-relaxed">
          O painel administrativo requer uma tela maior para melhor experiência e visualização dos dados.
        </p>
        
        <div className="bg-teal-50 rounded-xl p-4 mb-6">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-xl text-teal-600 mt-0.5"></i>
            <div className="text-left">
              <p className="text-sm font-semibold text-teal-900 mb-1">
                Como acessar:
              </p>
              <p className="text-sm text-teal-700">
                Utilize um computador ou tablet em modo paisagem para acessar todas as funcionalidades administrativas.
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
          <i className="ri-smartphone-line"></i>
          <span>Resolução mínima: 1024px</span>
        </div>
      </div>
    </div>
  );
}
